// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { chainIdToChainConfigurationValues, testAssetChains } from './DeploymentConfigsDefaults'
import { StageConfiguration } from './DeploymentConfigTypes'
import { ChainConfiguration } from './DeploymentConfigTypes'
import { ChainId } from './Enums'

const cognitoRegion = 'us-east-1'
const cognitoOTUserPoolId = 'us-east-1_pradU8JuA' // IN Production these are 2 different pools
const cognitoLytUserPoolId = 'us-east-1_pradU8JuA'

const QA_SEPOLIA_FRONTEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/ZfYMU4EmOzmizBu2ybqI8'
const QA_SEPOLIA_BACKEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/0Sa6UL3L0k0HbKdr-h5SJ'
const QA_FUJI_FRONTEND_URL = 'https://avax-fuji.g.alchemy.com/v2/4cSE9_-9aE5rv6QJtMm9U'
const QA_FUJI_BACKEND_URL = 'https://avax-fuji.g.alchemy.com/v2/_ESugHwjHIW_-ezv1xUvy'

const PROD_AVALANCHE_FRONTEND_URL = 'https://avax-mainnet.g.alchemy.com/v2/p5dgOkAqxryvxryB4To24'
const PROD_AVALANCHE_BACKEND_URL = 'https://avax-mainnet.g.alchemy.com/v2/YZGQb5WG7Ax8YmC51A7vW'

// WebSocket URLs
const QA_SEPOLIA_FRONTEND_WS_URL = 'wss://eth-sepolia.g.alchemy.com/v2/ZfYMU4EmOzmizBu2ybqI8'
const QA_FUJI_FRONTEND_WS_URL = 'wss://avax-fuji.g.alchemy.com/v2/4cSE9_-9aE5rv6QJtMm9U'
const PROD_AVALANCHE_FRONTEND_WS_URL = 'wss://avax-mainnet.g.alchemy.com/v2/p5dgOkAqxryvxryB4To24'

const QASEP_SERVICE_CONFIGURATION_ADDR = '0xC14b54FA8417D2a1D6Ecc31563e0a5e9E090C449' // '0xbedd20F7613b4cCEbdDf7C7296460319B8e1934E' // '0xfF8C215A77847cd152AD095d0bEDFa2f70617c74' // '0x4B9AD4442F220199FE4a61093126A1E95Ce29D61' // '0x9455e81215d0176347632C93C78bA060B2FF03FB' //'0x1D6e4758EE51Ed1976700fc1efd594cCff9436F9' // '0x3d5bfB2D620F8eF3077f2df5033FdbDB8872969F'

const QA_FUJI_SERVICE_CONFIGURATION_ADDR = '0x7660F78F8dD9Be7Dc6F1B14c5E79Ed4833a88939' // '0x7760Ac87014De4014512Cc1af35e614eF6a46117' // '0x755449CBAa22E162B9Be9048085E1Ec3702B2Da8'
const QA_AVALANCHE_SERVICE_CONFIGURATION_ADDR = '0xF7a7f699ACec3FE1E2dcE29EE589560D9f343BF5' // '0x7760Ac87014De4014512Cc1af35e614eF6a46117' // '0x755449CBAa22E162B9Be9048085E1Ec3702B2Da8'
const LYT_QA_FB_SERVICE_CONFIGURATION_ADDR = '0x3128821f16fAdc52666a7f32B733B0b6C20469B7'
const QA_PLUME_TESTNET_SERVICE_CONFIGURATION_ADDR = '0xFe9a0e57d8046d1Ebb6179FF9C48BCc7FA5D1439'

const LYT_QA_AVALANCHE_SERVICE_CONFIGURATION_ADDR = '0x7a80962E41d5748fB75E77e31dC43203a9EB3Ea6'

const QA_REST_API_KEY = 'YT89KuGtNc7Q21cO8v0Zr6MD7EPEbiE99KKDvt7j'

const CHAIN_CONFIG_QA_FUJI: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.FUJI),
  chainConfigurationName: 'QaFuji',
  serviceConfigurationAddr: QA_FUJI_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: QA_FUJI_FRONTEND_URL,
  frontendWebSocketProviderUrl: QA_FUJI_FRONTEND_WS_URL,
  backendProviderUrl: QA_FUJI_BACKEND_URL,
  hiddenInvestVaultAddresses: ['0xE481434BFf9666125296C921dC5EAea640bd9EE6'],
}

const CHAIN_CONFIG_QA_AVALANCHE: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.AVALANCHE),
  chainConfigurationName: 'QaAvalanche',
  serviceConfigurationAddr: QA_AVALANCHE_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_AVALANCHE_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_AVALANCHE_FRONTEND_WS_URL,
  backendProviderUrl: PROD_AVALANCHE_BACKEND_URL,
}

const CHAIN_CONFIG_LYT_QA_AVALANCHE: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.AVALANCHE),
  chainConfigurationName: 'LytQaAvalanche',
  serviceConfigurationAddr: LYT_QA_AVALANCHE_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: PROD_AVALANCHE_FRONTEND_URL,
  frontendWebSocketProviderUrl: PROD_AVALANCHE_FRONTEND_WS_URL,
  backendProviderUrl: PROD_AVALANCHE_BACKEND_URL,
}

const CHAIN_CONFIG_LYT_QA_FB: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.FUJI),
  chainConfigurationName: 'LytQaFujiAdmin',
  serviceConfigurationAddr: LYT_QA_FB_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: QA_FUJI_FRONTEND_URL,
  frontendWebSocketProviderUrl: QA_FUJI_FRONTEND_WS_URL,
  backendProviderUrl: QA_FUJI_BACKEND_URL,
}

const CHAIN_CONFIG_QA_PLUME_TESTNET: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.PLUME_TESTNET),
  chainConfigurationName: 'QaPlume',
  serviceConfigurationAddr: QA_PLUME_TESTNET_SERVICE_CONFIGURATION_ADDR,
}

const CHAIN_CONFIG_QA_SEPOLIA: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.SEPOLIA),
  chainConfigurationName: 'QaSepolia',
  serviceConfigurationAddr: QASEP_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: QA_SEPOLIA_FRONTEND_URL,
  frontendWebSocketProviderUrl: QA_SEPOLIA_FRONTEND_WS_URL,
  backendProviderUrl: QA_SEPOLIA_BACKEND_URL,
}

export const QA_STAGE_CONFIG: StageConfiguration = {
  stageName: 'qa', // from serverless.yml
  domain: 'app.opentradeqa.com',
  websocketUrl: 'wss://ws.opentradeqa.com',
  serverApiBaseUrl: 'https://api.opentradeqa.com',
  graphqlUrl: 'https://gql.opentradeqa.com',
  restAPIKey: QA_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [
    CHAIN_CONFIG_QA_SEPOLIA,
    CHAIN_CONFIG_QA_FUJI,
    CHAIN_CONFIG_QA_AVALANCHE,
    CHAIN_CONFIG_QA_PLUME_TESTNET,
  ],
  userConnections: [],
  cognitoConfig: {
    clientId: 'lap2ehse3165qke0vq66n5nd7',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const QA_LYT_STAGE_CONFIG: StageConfiguration = {
  stageName: 'qasierra', // from serverless.yml
  domain: 'app.sierraqa.com',
  websocketUrl: '',
  serverApiBaseUrl: 'https://api.sierraqa.com',
  graphqlUrl: '',
  lytPoolAddr: '0x4F2AC6F077B1678A1E22Db76194BDb8347D10118',
  restAPIKey: QA_REST_API_KEY,
  supportedChains: [
    { name: 'Avalanche', chain: 'Avalanche', chainID: ChainId.AVALANCHE, rpcUrl: PROD_AVALANCHE_FRONTEND_URL },
  ],
  chainConfigurations: [CHAIN_CONFIG_LYT_QA_AVALANCHE],
  userConnections: [],
  cognitoConfig: {
    clientId: '7958atbamfp7c6uao88o92801u',
    userPoolId: cognitoLytUserPoolId,
    region: cognitoRegion,
  },
  parentStageConfiguration: QA_STAGE_CONFIG,
  parentChainConfiguration: CHAIN_CONFIG_QA_AVALANCHE,
  isLyt: true,

  oftAdapter: '0x0fEd7B404101DC241371a19198b5c671a4B65D7A',
  layerZeroEid: 30106, //AVALANCHE_V2_MAINNET
}

export const QA_LYT_STAGE_CONFIG_FB: StageConfiguration = {
  stageName: 'qasierrafb', // from serverless.yml
  domain: 'app.sierraqafb.com',
  websocketUrl: '',
  serverApiBaseUrl: 'https://api.sierraqafb.com',
  graphqlUrl: '',
  lytPoolAddr: '0xF792063Ae00955455e156e746eB6ee24ff2b5B41',
  restAPIKey: QA_REST_API_KEY,
  supportedChains: [{ name: 'Fuji', chain: 'Fuji', chainID: ChainId.FUJI, rpcUrl: QA_FUJI_FRONTEND_URL }],
  chainConfigurations: [CHAIN_CONFIG_LYT_QA_FB],
  userConnections: [],
  cognitoConfig: {
    clientId: '64f03gsfnvv7tt5an8glnijue0',
    userPoolId: cognitoLytUserPoolId,
    region: cognitoRegion,
  },
  parentStageConfiguration: QA_STAGE_CONFIG,
  parentChainConfiguration: CHAIN_CONFIG_QA_FUJI,
  isLyt: true,

  oftAdapter: '0x8B9DCCf3B8d5F1dC9F2Ab9f34cA8dc674FfDe6Ae',
  layerZeroEid: 40106, // AVALANCHE_V2_TESTNET (Fuji)
}
